import request from '@/lib/request/';

const baseUri = 'auth/login';

/**
 * @param data {Object}
 * @returns {Promise}
 */
export function post(data) {
  return request({
    url: baseUri,
    method: 'post',
    data,
    qs: true,
  });
}
